import React, { useState } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'

import { hasErrors } from './'
import FormError from './FormError'

const propTypes = {
  id: PropTypes.string.isRequired,
}

const DateField = ({ id, field, form, ...props }) => {
  const [startDate, setStartDate] = useState(null)
  const { onBlur } = field
  return (
    <>
      <div className="mb-6">
        <DatePicker
          dateFormat="dd/MM/yyyy"
          showPopperArrow={false}
          id={id}
          autoComplete="off"
          onBlur={() => {
            form.setFieldTouched(id, true)
            onBlur()
          }}
          selected={startDate}
          onChange={date => {
            setStartDate(date)
            date
              ? form.setFieldValue(id, date.toLocaleDateString('en-GB'))
              : form.setFieldValue(id, '')
          }}
          className={`w-full py-4 px-6 text-lg rounded-lg bg-primary-lighter placeholder-black ${
            hasErrors({ field, form })
              ? 'border border-error'
              : 'border border-transparent'
          }`}
        />
        {hasErrors({ field, form }) && (
          <FormError error={form.errors[field.name]} />
        )}
      </div>
    </>
  )
}

DateField.propTypes = propTypes

export default DateField
